function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3584_1652)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M65.0708 22.4898H37.4515C36.8221 22.4905 36.2187 22.7408 35.7737 23.1856C35.3286 23.6304 35.0782 24.2335 35.0775 24.8625V86.2143L34.7609 86.3108L27.9855 88.3846C27.6644 88.4825 27.3176 88.449 27.0211 88.2915C26.7247 88.134 26.5029 87.8654 26.4044 87.5447L6.25056 21.7479C6.15248 21.4269 6.18591 21.0802 6.3435 20.7839C6.50109 20.4876 6.76994 20.2659 7.09097 20.1676L17.5319 16.9723L47.8007 7.71217L58.2415 4.51685C58.4004 4.46797 58.5674 4.45089 58.7329 4.46659C58.8984 4.48228 59.0592 4.53044 59.2061 4.60832C59.3529 4.68619 59.483 4.79224 59.5888 4.9204C59.6946 5.04857 59.7741 5.19633 59.8227 5.35523L64.9743 22.1734L65.0708 22.4898Z",
  fill: "#F2F2F2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.0971 22.174L64.8883 1.90423C64.785 1.5665 64.6161 1.25242 64.3913 0.979943C64.1665 0.707467 63.8902 0.481933 63.5782 0.316228C63.2662 0.150523 62.9245 0.0478941 62.5728 0.0142089C62.221 -0.0194762 61.8661 0.0164428 61.5283 0.11991L46.8489 4.61076L16.5818 13.8725L1.90248 18.3649C1.22056 18.5742 0.64957 19.0453 0.314856 19.675C-0.0198589 20.3046 -0.0909569 21.0412 0.11717 21.7231L21.3377 90.9968C21.5068 91.5473 21.848 92.0291 22.3111 92.3716C22.7743 92.7141 23.3351 92.8992 23.9112 92.8998C24.1779 92.8999 24.443 92.8599 24.6978 92.7811L34.7604 89.7029L35.077 89.6048V89.2742L34.7604 89.3707L24.6044 92.479C24.0025 92.6624 23.3524 92.5997 22.7966 92.3046C22.2409 92.0096 21.825 91.5062 21.6401 90.9051L0.42111 21.6298C0.329487 21.3319 0.297554 21.0189 0.327138 20.7087C0.356722 20.3985 0.44724 20.0971 0.593515 19.8219C0.739789 19.5467 0.938946 19.303 1.17958 19.1049C1.42021 18.9067 1.69758 18.7579 1.99583 18.667L16.6752 14.1746L46.9424 4.91448L61.6217 0.422045C61.8479 0.353045 62.0831 0.317863 62.3196 0.317643C62.8272 0.318782 63.3211 0.482337 63.7289 0.784353C64.1368 1.08637 64.4371 1.51098 64.5861 1.99598L70.7664 22.174L70.8645 22.4903H71.1937L71.0971 22.174Z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.417 20.22C19.112 20.2197 18.815 20.1218 18.5697 19.9406C18.3244 19.7593 18.1437 19.5043 18.0541 19.2128L16.0156 12.5577C15.9608 12.379 15.9418 12.1912 15.9596 12.0051C15.9775 11.819 16.0318 11.6382 16.1196 11.4731C16.2073 11.308 16.3268 11.1618 16.4711 11.0428C16.6154 10.9238 16.7817 10.8344 16.9606 10.7797L44.8061 2.25931C45.1673 2.14914 45.5575 2.18672 45.8911 2.36379C46.2246 2.54086 46.4742 2.84296 46.5851 3.20379L48.6237 9.85896C48.7339 10.22 48.6962 10.61 48.5191 10.9433C48.3419 11.2767 48.0397 11.5261 47.6787 11.6371L19.8332 20.1575C19.6983 20.1988 19.5581 20.2199 19.417 20.22Z",
  fill: "url(#paint0_linear_3584_1652)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.095 7.11058C31.8432 7.11058 33.2604 5.69415 33.2604 3.94689C33.2604 2.19963 31.8432 0.783203 30.095 0.783203C28.3469 0.783203 26.9297 2.19963 26.9297 3.94689C26.9297 5.69415 28.3469 7.11058 30.095 7.11058Z",
  fill: "#6C63FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.0942 5.95005C31.2012 5.95005 32.0986 5.05312 32.0986 3.9467C32.0986 2.84029 31.2012 1.94336 30.0942 1.94336C28.9872 1.94336 28.0898 2.84029 28.0898 3.9467C28.0898 5.05312 28.9872 5.95005 30.0942 5.95005Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.3789 92.0917H41.8843C41.5277 92.0913 41.1857 91.9495 40.9335 91.6974C40.6813 91.4453 40.5395 91.1036 40.5391 90.7471V26.6825C40.5395 26.326 40.6813 25.9842 40.9335 25.7321C41.1857 25.4801 41.5277 25.3383 41.8843 25.3379H95.3789C95.7355 25.3383 96.0775 25.4801 96.3297 25.7322C96.5819 25.9842 96.7237 26.326 96.7242 26.6825V90.7471C96.7237 91.1036 96.5819 91.4453 96.3297 91.6974C96.0775 91.9495 95.7355 92.0913 95.3789 92.0917Z",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M87.4162 64.5252C85.7516 72.9518 78.409 79.0206 69.8789 79.02C65.1373 79.0197 60.5899 77.1223 57.2371 73.7452C51.2054 67.6698 50.2746 58.149 55.0138 51.0053C59.753 43.8616 68.8424 41.0847 76.723 44.373C84.6037 47.6612 89.0808 56.0986 87.4162 64.5252ZM84.0235 58.1758C82.682 51.3805 76.7616 46.4859 69.883 46.4854C66.0589 46.4852 62.3913 48.015 59.6871 50.7385C54.823 55.6373 54.0718 63.3148 57.8931 69.0757C61.7143 74.8366 69.0436 77.0765 75.3988 74.4255C81.754 71.7746 85.365 64.9711 84.0235 58.1758Z",
  fill: "url(#paint1_linear_3584_1652)",
  fillOpacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.0938 60.1113H71.6699V70.9173H68.0938V60.1113Z",
  fill: "url(#paint2_linear_3584_1652)",
  fillOpacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.0938 52.0059H71.6699V55.6079H68.0938V52.0059Z",
  fill: "url(#paint3_linear_3584_1652)",
  fillOpacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.7677 22.1738H37.4523C36.739 22.1748 36.0552 22.4585 35.5509 22.9626C35.0465 23.4667 34.7627 24.1501 34.7617 24.863V89.3705L35.0783 89.274V24.863C35.079 24.2339 35.3294 23.6308 35.7744 23.186C36.2195 22.7412 36.8229 22.491 37.4523 22.4902H70.8658L70.7677 22.1738ZM99.8098 22.1738H37.4523C36.739 22.1748 36.0552 22.4585 35.5509 22.9626C35.0465 23.4667 34.7627 24.1501 34.7617 24.863V97.3114C34.7627 98.0243 35.0465 98.7077 35.5509 99.2118C36.0552 99.7159 36.739 99.9995 37.4523 100.001H99.8098C100.523 99.9995 101.207 99.7159 101.711 99.2118C102.216 98.7077 102.499 98.0243 102.5 97.3114V24.863C102.499 24.1501 102.216 23.4667 101.711 22.9626C101.207 22.4585 100.523 22.1748 99.8098 22.1738ZM102.184 97.3114C102.183 97.9405 101.933 98.5435 101.488 98.9883C101.043 99.4332 100.439 99.6834 99.8098 99.6842H37.4523C36.8229 99.6834 36.2195 99.4332 35.7744 98.9883C35.3294 98.5435 35.079 97.9405 35.0783 97.3114V24.863C35.079 24.2339 35.3294 23.6308 35.7744 23.186C36.2195 22.7412 36.8229 22.491 37.4523 22.4902H99.8098C100.439 22.491 101.043 22.7412 101.488 23.186C101.933 23.6308 102.183 24.2339 102.184 24.863V97.3114Z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.1922 29.1336H54.0709C53.6932 29.1332 53.3312 28.983 53.0641 28.7162C52.7971 28.4493 52.6469 28.0874 52.6465 27.7099V20.7498C52.6469 20.3724 52.7971 20.0105 53.0642 19.7436C53.3312 19.4767 53.6932 19.3266 54.0709 19.3262H83.1922C83.5698 19.3266 83.9319 19.4767 84.1989 19.7436C84.466 20.0105 84.6162 20.3724 84.6166 20.7498V27.7099C84.6162 28.0874 84.466 28.4493 84.1989 28.7162C83.9319 28.983 83.5698 29.1332 83.1922 29.1336Z",
  fill: "url(#paint4_linear_3584_1652)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.6302 19.8C70.3784 19.8 71.7956 18.3836 71.7956 16.6363C71.7956 14.8891 70.3784 13.4727 68.6302 13.4727C66.882 13.4727 65.4648 14.8891 65.4648 16.6363C65.4648 18.3836 66.882 19.8 68.6302 19.8Z",
  fill: "#6C63FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.6311 18.5629C69.6959 18.5629 70.5591 17.7002 70.5591 16.636C70.5591 15.5717 69.6959 14.709 68.6311 14.709C67.5663 14.709 66.7031 15.5717 66.7031 16.636C66.7031 17.7002 67.5663 18.5629 68.6311 18.5629Z",
  fill: "white"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_3584_1652",
  x1: 32.3194,
  y1: 2.19727,
  x2: 32.3194,
  y2: 20.22,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#753CBE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3CC0C3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_3584_1652",
  x1: 56.7151,
  y1: 48.5724,
  x2: 81.5768,
  y2: 74.2914,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#753CBE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3CC0C3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_3584_1652",
  x1: 68.5653,
  y1: 61.7831,
  x2: 73.1651,
  y2: 63.3692,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#753CBE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3CC0C3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_3584_1652",
  x1: 68.5653,
  y1: 52.5631,
  x2: 71.0514,
  y2: 55.135,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#753CBE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3CC0C3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_3584_1652",
  x1: 68.6315,
  y1: 19.3262,
  x2: 68.6315,
  y2: 29.1336,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#753CBE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3CC0C3"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3584_1652"
}, /*#__PURE__*/React.createElement("rect", {
  width: 102.5,
  height: 100,
  fill: "white"
})));
function SvgDashNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 100,
    viewBox: "0 0 103 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashNoData);
export default __webpack_public_path__ + "static/media/dash-noData.12b2a6f093abc1c8a068a2ef97a6a2e2.svg";
export { ForwardRef as ReactComponent };